import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import { Button } from 'react-bootstrap';

const AssignmentsUsedBy = ({ usedAssignments, showUsedByModal, setShowUsedByModal }) => {
  return (
    <Modal
      isOpen={showUsedByModal}
      onClose={() => setShowUsedByModal(false)}
      titleName='Question Found in...'
      contentWidth='40%'>
      <div className='d-flex flex-column'>
        <table className='table list-table'>
          <thead>
            <th>Assignment</th>
            <th>Course</th>
          </thead>
          <tbody>
            {usedAssignments?.map((usedBy, index) => {
              return (
                <tr key={`assignmentRow_${index}`}>
                  <td>{usedBy.assignmentName}</td>
                  <td>{usedBy.courseName}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className='d-flex flex-row justify-content-end mt-4'><Button variant='castleRed' className='w-25' onClick={() => setShowUsedByModal(false)}>Ok</Button></div>
      </div>
    </Modal>
  );
};
AssignmentsUsedBy.propTypes = {
  usedAssignments: PropTypes.array.isRequired,
  showUsedByModal:PropTypes.bool,
  setShowUsedByModal:PropTypes.func
};

export default AssignmentsUsedBy;
